export default class TipoSituacao {

  constructor(
    IdTipoSituacao = null,
    Descricao = '',
    Status = 'A'
  ) {
    this.IdTipoSituacao = IdTipoSituacao;
    this.Descricao = Descricao;
    this.Status = Status;
  }
  
}